import sanitizeHtml from "sanitize-html";

import { SupportedLocales, isValidLocale } from "./utils/localization";
import { getProductNameFromBundle, Bundle } from "./utils/urls";

export type RouteWithVariant =
    | {
          locale: SupportedLocales;
          featureFlags: Record<string, boolean>;
          product?: string;
      } & (
          | { path: ""; variant: undefined; search: string }
          | { path: "uniform-preview"; variant: undefined; search: string }
          | { path: "uniform-entry"; variant: undefined; search: string }
          | { path: "buy/cloud/org-setup"; variant: undefined; search: string }
          | { path: "buy/cloud/site-setup"; variant: undefined; search: string }
          | {
                path: "software/rovo/pricing";
                variant: undefined;
                search: string;
            }
          | {
                path: "software/jira/product-discovery/pricing";
                variant: undefined;
                search: string;
            }
          | {
                path: "software/bitbucket/pricing";
                variant: undefined;
                search: string;
            }
          | {
                path: "software/loom/pricing";
                variant: undefined;
                search: string;
            }
          | {
                path: `software/loom${string}`;
                variant: undefined;
                search: string;
            }
          | {
                path: "buy/cloud/post-order-provisioning";
                variant: undefined;
                search: string;
            }
          | { path: "software/rovo/start"; variant: undefined; search: string }
          | { path: "customers"; variant: undefined; search: string }
          | {
                path: "software/jira";
                variant:
                    | "paid-lp-jsw-roadmaps"
                    | "paid-lp-jsw-tracker"
                    | "paid-lp-jsw-template"
                    | "paid-lp-jsw-pm"
                    | "paid-lp-jsw-features"
                    | "paid-lp-jsw-project_collaboration"
                    | "paid-lp-jsw-automation"
                    | "paid-lp-jsw-teamwork"
                    | "paid-lp-jsw-agile"
                    | "paid-lp-jsw-competitors"
                    | "anchor-lp-jsw-team-engineering"
                    | "anchor-lp-jsw-team-marketing"
                    | "anchor-lp-jsw-team-hr"
                    | "anchor-lp-jsw-team-legal"
                    | "anchor-lp-jsw-team-operations"
                    | "anchor-lp-jsw-team-design"
                    | "anchor-lp-jsw-team-programmgmt"
                    | "anchor-lp-jsw-team-sales";
                search: string;
            }
          | {
                path: "software/jira/pricing";
                variant: undefined;
                search: string;
            }
          | {
                path: "software/jira/service-management";
                variant:
                    | "anchor-lp-jsm-automation"
                    | "anchor-lp-jsm-competitors"
                    | "anchor-lp-jsm-esm"
                    | "anchor-lp-jsm-csm"
                    | "anchor-lp-jsm-asset"
                    | "anchor-lp-jsm-team-customerservice"
                    | "anchor-lp-jsm-team-design"
                    | "anchor-lp-jsm-devops"
                    | "anchor-lp-jsm-team-marketing"
                    | "anchor-lp-jsm-team-engineering"
                    | "anchor-lp-jsm-team-hr"
                    | "anchor-lp-jsm-team-legal"
                    | "anchor-lp-jsm-team-operations"
                    | "paid-lp-jsm-features"
                    | "paid-lp-jsm-ticketing"
                    | "paid-lp-jsm-service-desk"
                    | "paid-lp-jsm-features-cerebro"
                    | "paid-lp-jsm-itsm"
                    | "paid-lp-jsm-incidentchangemgmt";
                search: string;
            }
          | {
                path: "software/jira/service-management/pricing";
                variant: undefined;
                search: string;
            }
          | {
                path: "software/jira/service-management/product-pricing";
                variant: undefined;
                search: string;
            }
          | {
                path: "software/confluence";
                variant:
                    | "paid-lp-conf-features"
                    | "paid-lp-confl-template"
                    | "paid-lp-confl-documentation"
                    | "paid-lp-confl-projectmgmt"
                    | "anchor-lp-conf-collaboration"
                    | "anchor-lp-conf-automation"
                    | "anchor-lp-conf-teamwork"
                    | "anchor-lp-conf-competitors"
                    | "anchor-lp-conf-team-engineering"
                    | "anchor-lp-conf-work-management"
                    | "anchor-lp-conf-work-management"
                    | "anchor-lp-conf-team-marketing"
                    | "anchor-lp-conf-team-legal"
                    | "anchor-lp-conf-team-hr"
                    | "anchor-lp-conf-team-operations"
                    | "anchor-lp-conf-team-design"
                    | "anchor-lp-conf-team-programmgmt"
                    | "anchor-lp-conf-team-customerservice";
                search: string;
            }
          | {
                path: "software/confluence/pricing";
                variant: undefined;
                search: string;
            }
          | {
                path: "software/confluence/templates";
                variant: undefined;
                search: string;
            }
          | {
                path: `software/confluence/templates/search`;
                variant: undefined;
                search: string;
            }
          | {
                path: "software/jira/features";
                variant: undefined;
                search: string;
            }
          | {
                path: "software/jira/free";
                variant: undefined;
                search: string;
            }
          | {
                path: "software/confluence/free";
                variant: undefined;
                search: string;
            }
          | {
                path: "software";
                variant: undefined;
                search: string;
            }
          | {
                path: "try";
                variant: undefined;
                search: string;
            }
          | {
                path: "try/cloud/signup";
                variant: undefined;
                search: string;
            }
          | {
                path: "ondemand/signup/checkemail";
                variant: undefined;
                search: string;
            }
          | {
                path: "ondemand/signup/confirmation";
                variant: undefined;
                search: string;
            }
          | {
                path: "buy/cloud/confirmation";
                variant: undefined;
                search: string;
            }
          | {
                path: `software/jira/templates/${string}`;
                variant: undefined;
                search: string;
            }
          | {
                path: `software/confluence/template${string}`;
                variant: undefined;
                search: string;
            }
          | {
                path: `software/jira/product-discovery`;
                variant: undefined;
                search: string;
            }
          | {
                path: "enterprise/contact";
                variant:
                    | "product-features"
                    | "pricing-quotes"
                    | "migration-options"
                    | "billing-licensing"
                    | "technical-support";
                search: string;
            }
          | {
                path: "enterprise/contact-thanks";
                variant:
                    | "product-features"
                    | "pricing-quotes"
                    | "migration-options"
                    | "billing-licensing"
                    | "technical-support";
                search: string;
            }
          | {
                path: "404";
                variant: undefined;
                search: string;
            }
          | {
                path: "teams/nonprofits/discount-pricing";
                variant: undefined;
                search: string;
            }
          | {
                path: "cdn-library";
                variant: undefined;
                search: string;
            }
          | {
                path: "search";
                variant: undefined;
                search: string;
            }
          | {
                path: `itsm${string}`;
                variant: undefined;
                search: string;
            }
          | {
                path: `incident-management${string}`;
                variant: undefined;
                search: string;
            }
          | {
                path: `devops${string}`;
                variant: undefined;
                search: string;
            }
          | {
                path: `continuous-delivery${string}`;
                variant: undefined;
                search: string;
            }
          | {
                path: `microservices${string}`;
                variant: undefined;
                search: string;
            }
          | {
                path: `data${string}`;
                variant: undefined;
                search: string;
            }
      );

/**
 * Removes trailing slashes from a route path for consistent matching
 * Preserves empty paths (root route)
 * @param path - The path to normalize
 * @returns The path without trailing slashes
 */
const removeTrailingSlash = (path: string): string => {
    // Don't remove slash from empty paths (root "/")
    if (path.length <= 1) {
        return path;
    }
    // Remove single trailing slash
    return path.endsWith("/") ? path.slice(0, -1) : path;
};

export const getFeatureFlagValues = (params: string[]) => {
    // set defaults for feature flags
    const featureFlags = {
        enableBundlesAfterSignup: false,
        enableCutSignUpStepsInHalf: false,
        provisionSecondPartyApps: false
    };
    params[0] && (params[0] = params[0].replace(/^\?(.+)/, "$1"));
    params.forEach((param) => {
        const [key, value] = param.split("=");
        switch (key) {
            case "provisionSecondPartyApps":
                if (value === "enableProvisionSecondPartyApps") {
                    featureFlags.provisionSecondPartyApps = true;
                }
                break;
        }
    });
    return featureFlags;
};

export const parseRoute = (
    location: Location
): RouteWithVariant & {
    locale: SupportedLocales;
    featureFlags: object;
    persona?: string;
    teamType?: string;
    keyword?: string;
    mlTemplateIds?: string[];
    referrer?: string;
    isUniformCanary?: boolean;
    anchor?: string;
    subAnchor?: string;
    referralSource?: string;
    publicQueryParams?: string;
    clusterTag?: string;
    utmMedium?: string;
    utmContent?: string;
    utmCampaign?: string;
    // eslint-disable-next-line complexity
} => {
    // remove all leading slashes (server had 2 leading slashes, client has 1)
    const noSlashPrefixPath = location.pathname.replace(/^\/+/, "");
    if (noSlashPrefixPath === "index.html") {
        // case for the unlocalized home page
        return {
            locale: "en",
            path: "",
            variant: undefined,
            search: "",
            featureFlags: {}
        };
    }

    // check if the route has a locale prefix
    const potentialLocale = noSlashPrefixPath.split("/")[0] || "";
    const localeIsValid = isValidLocale(potentialLocale);

    // if there is a locale prefix, set the locale variable and remove the prefix from the path
    // otherwise, set the locale to the default (en) and leave the path as is
    const locale = localeIsValid ? potentialLocale : "en";
    const pathWithoutLocale = localeIsValid
        ? noSlashPrefixPath.slice(locale.length + 1)
        : noSlashPrefixPath;

    // Remove trailing slashes for consistent route matching
    // This ensures /software/jira/ matches the same route as /software/jira
    const cleanedPath = removeTrailingSlash(
        pathWithoutLocale
    ) as RouteWithVariant["path"];

    const params = location.search.split("&");

    let cmsVariantValue = params
        .filter((param) => param.includes("cmsVariant"))[0]
        ?.split("=")[1] as RouteWithVariant["variant"];
    const rawPersona = params
        .filter((param) => param.includes("persona"))[0]
        ?.split("=")[1];
    const isUniformCanary = params
        .filter((param) => param.includes("canary"))[0]
        ?.split("=")[1];

    const keyword = sanitizeHtml(
        decodeURIComponent(
            params
                .filter((param) => param.includes("keyword"))[0]
                ?.split("=")[1] || ""
        )
    );
    const anchor = sanitizeHtml(
        decodeURIComponent(
            params
                .filter((param) => param.includes("anchor"))[0]
                ?.split("=")[1] || ""
        )
    );
    const subAnchor = sanitizeHtml(
        decodeURIComponent(
            params
                .filter((param) => param.includes("subAnchor"))[0]
                ?.split("=")[1] || ""
        )
    );
    const mlTemplateIds = sanitizeHtml(
        decodeURIComponent(
            params
                .filter((param) => param.includes("mlTemplateIds"))[0]
                ?.split("=")[1] || ""
        )
    )
        .split(",")
        .filter((i) => i !== "");

    //if they were redirected from jira.com, set referrer to jira.com
    const referrer =
        params
            .filter((param) => param.includes("referer"))[0]
            ?.split("=")[1] === "jira.com"
            ? "jira.com"
            : "";

    const referralSource = decodeURIComponent(
        params
            .filter((param) => param.includes("referralSource"))[0]
            ?.split("=")[1] || ""
    );

    // publicQueryParams is double encoded
    const publicQueryParams = decodeURIComponent(
        decodeURIComponent(
            params
                .filter((param) => param.includes("publicQueryParams"))[0]
                ?.split("=")[1] || ""
        )
    );

    const clusterTag = sanitizeHtml(
        decodeURIComponent(
            params
                .filter((param) => param.includes("anchor="))[0]
                ?.split("=")[1] || ""
        )
    );

    const utmMedium = sanitizeHtml(
        decodeURIComponent(
            params
                .filter((param) => param.includes("utm_medium"))[0]
                ?.split("=")[1] || ""
        )
    );

    const utmContent = sanitizeHtml(
        decodeURIComponent(
            params
                .filter((param) => param.includes("utm_content"))[0]
                ?.split("=")[1] || ""
        )
    );

    const utmCampaign = sanitizeHtml(
        decodeURIComponent(
            params
                .filter((param) => param.includes("utm_campaign"))[0]
                ?.split("=")[1] || ""
        )
    );

    let persona = undefined;
    try {
        // if rawPersona is malformed or incidentally a unicode sequence, decodeURIComponent will throw an error
        persona = rawPersona ? decodeURIComponent(rawPersona) : undefined;
    } catch (e) {
        console.error("Error decoding persona parameter", e, rawPersona);
    }

    const teamType = sanitizeHtml(
        decodeURIComponent(
            params
                .filter((param) => param.includes("team_type"))[0]
                ?.split("=")[1] || ""
        )
    );
    if (cleanedPath.includes("enterprise")) {
        // Use formType parameter if cleanedPath contains 'enterprise'
        cmsVariantValue = params
            .filter((param) => param.includes("formType"))[0]
            ?.split("=")[1] as RouteWithVariant["variant"];
    }

    const featureFlags = getFeatureFlagValues(params);

    const bundleParam = decodeURIComponent(
        params.filter((param) => param.includes("bundle"))[0]?.split("=")[1] ||
            ""
    );

    const productParam = decodeURIComponent(
        params.filter((param) => param.includes("product"))[0]?.split("=")[1] ||
            ""
    );

    const product = getProductNameFromBundle(
        bundleParam as Bundle,
        productParam
    );

    return {
        path: cleanedPath,
        variant: cmsVariantValue,
        locale,
        search: location.search,
        featureFlags,
        persona: persona,
        teamType: teamType,
        keyword: keyword,
        mlTemplateIds: mlTemplateIds,
        referrer: referrer,
        isUniformCanary,
        product,
        anchor,
        subAnchor,
        referralSource,
        publicQueryParams,
        clusterTag,
        utmMedium,
        utmContent,
        utmCampaign
    } as RouteWithVariant & {
        locale: SupportedLocales;
        featureFlags: object;
        persona?: string;
        teamType?: string;
        keyword?: string;
        mlTemplateIds?: string[];
        referrer?: string;
        isUniformCanary?: boolean;
        anchor?: string;
        subAnchor?: string;
        referralSource?: string;
        publicQueryParams?: string;
        clusterTag?: string;
        utmMedium?: string;
        utmContent?: string;
        utmCampaign?: string;
    };
};
